// extracted by mini-css-extract-plugin
export var askAiIcon = "_md-9";
export var container = "_md-0";
export var groupSeparator = "_md-a";
export var highlight = "_md-4";
export var resultIcon = "_md-5";
export var resultItem = "_md-7";
export var resultSubtitle = "_md-3";
export var resultTitle = "_md-2";
export var resultsList = "_md-1";
export var searchGroup = "_md-6";
export var selected = "_md-8";